// Composant TrustBadge - Badge "Super Confiance" ou "Confiance"
// Affiché sur les profils des utilisateurs invités dans le Cercle de Confiance

import { Crown, Shield } from 'lucide-react';

/**
 * Badge de confiance pour les utilisateurs VIP
 * @param {string} trustLevel - "super_confiance" ou "confiance"
 * @param {string} size - "sm", "md", "lg"
 * @param {boolean} showLabel - Afficher le texte ou juste l'icône
 */
export function TrustBadge({ trustLevel, size = 'md', showLabel = true }) {
  if (!trustLevel || (trustLevel !== 'super_confiance' && trustLevel !== 'confiance')) {
    return null;
  }

  const isSuperConfiance = trustLevel === 'super_confiance';
  
  // Configurations de taille
  const sizes = {
    sm: {
      icon: 12,
      padding: '2px 6px',
      fontSize: '10px',
      gap: 4
    },
    md: {
      icon: 14,
      padding: '4px 10px',
      fontSize: '12px',
      gap: 5
    },
    lg: {
      icon: 16,
      padding: '6px 14px',
      fontSize: '14px',
      gap: 6
    }
  };

  const config = sizes[size] || sizes.md;
  
  // Styles selon le niveau
  const styles = isSuperConfiance ? {
    background: 'linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)',
    color: 'white',
    border: 'none',
    boxShadow: '0 2px 8px rgba(139,92,246,0.3)'
  } : {
    background: 'linear-gradient(135deg, #F97316 0%, #ea580c 100%)',
    color: 'white',
    border: 'none',
    boxShadow: '0 2px 8px rgba(249,115,22,0.3)'
  };

  const Icon = isSuperConfiance ? Crown : Shield;
  const label = isSuperConfiance ? 'Super Confiance' : 'Confiance';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: config.gap,
        padding: config.padding,
        borderRadius: 20,
        fontSize: config.fontSize,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        ...styles
      }}
      title={isSuperConfiance 
        ? "Membre Super Confiance - Peut inviter d'autres personnes" 
        : "Membre de Confiance - Vérifié par le réseau"
      }
    >
      <Icon size={config.icon} />
      {showLabel && <span>{label}</span>}
    </span>
  );
}

/**
 * Badge compact (juste l'icône avec tooltip)
 */
export function TrustBadgeIcon({ trustLevel, size = 16 }) {
  if (!trustLevel || (trustLevel !== 'super_confiance' && trustLevel !== 'confiance')) {
    return null;
  }

  const isSuperConfiance = trustLevel === 'super_confiance';
  const Icon = isSuperConfiance ? Crown : Shield;
  const color = isSuperConfiance ? '#8b5cf6' : '#F97316';
  const title = isSuperConfiance ? 'Super Confiance' : 'Confiance';

  return (
    <Icon 
      size={size} 
      style={{ color, fill: color, opacity: 0.9 }} 
      title={title}
    />
  );
}

export default TrustBadge;
